import { FC, useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import {
  Card,
  Typography,
} from '@beeline/design-system-react/extracted-styles';

import { EmployeePermission } from 'src/api/permissions';
import { labelsByRoute } from 'src/routes/consts';
import { RoutePath, TabItem } from 'src/routes/types';
import { getUserState } from 'src/store/user/selectors';

import classes from './Navigation.module.scss';

const tabs: TabItem[] = [
  {
    label: labelsByRoute[RoutePath.Administrator],
    path: RoutePath.Administrator,
    permission: EmployeePermission.EditPlans,
  },
  {
    label: labelsByRoute[RoutePath.Spaces],
    path: RoutePath.Spaces,
    permission: EmployeePermission.EditPlans,
  },
  {
    label: labelsByRoute[RoutePath.DeskBooking],
    path: RoutePath.DeskBooking,
    permission: EmployeePermission.BookDesks,
  },
  {
    label: labelsByRoute[RoutePath.RoomBooking],
    path: RoutePath.RoomBooking,
    permission: EmployeePermission.BookRooms,
  },
  {
    label: labelsByRoute[RoutePath.Parking],
    path: RoutePath.Parking,
    permission: EmployeePermission.BookParkingPlaces,
  },
  {
    label: labelsByRoute[RoutePath.MyBookings],
    path: RoutePath.MyBookings,
    permission: EmployeePermission.ViewBookedObjects,
  },
  {
    label: labelsByRoute[RoutePath.Search],
    path: RoutePath.Search,
    permission: EmployeePermission.ViewBookedObjects,
  },
];

export const Navigation: FC = () => {
  const navigate = useNavigate();
  const { data } = useSelector(getUserState);

  const tabItems = useMemo((): TabItem[] => {
    const result: TabItem[] = [];
    if (!data) return tabs;

    for (const tab of tabs) {
      if (data.permissions.has(tab.permission)) result.push(tab);
    }

    return result;
  }, [data]);

  const selectTab = useCallback(
    (tab: TabItem) => {
      navigate(tab.path);
    },
    [navigate],
  );

  return (
    <div className={classes.container}>
      {tabItems.map(tabItem => (
        <Card
          key={tabItem.path}
          border='default'
          onClick={() => {
            selectTab(tabItem);
          }}
          elevation='low'
        >
          <Typography variant='body2'>{tabItem.label}</Typography>
        </Card>
      ))}
    </div>
  );
};
